var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 39,
    viewBox: "0 0 22 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26953 29.0697C1.89912 34.1036 5.97783 37.8407 10.7607 37.766C16.0907 37.766 20.6263 33.7664 20.6263 27.8867L20.6251 28.0337L20.2629 21.4703C20.1646 20.1859 19.1415 19.2046 17.9279 19.2308H12.4142C9.1165 17.3445 1.37226 23.0864 1.37226 24.212",
    fill: "#FCEA2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27887 26.9648C2.16346 26.8754 0.93631 26.0086 1.00257 24.7994L1.03406 16.1468C0.894693 15.0154 2.97292 13.9133 4.01762 13.7624C5.06232 13.6115 5.46515 15.5087 5.60452 16.6401C6.18323 13.656 5.74921 16.0946 5.17049 20.5261V24.6235C5.23675 25.8327 4.39428 26.8754 3.27887 26.9648Z",
    fill: "#FCEA2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88185 29.7545C6.76644 29.6651 5.92391 28.6223 5.99023 27.4131L5.97325 15.841C5.57089 14.7837 2.87988 15.1227 7.67528 13.9142C8.70184 13.6556 9.42771 14.3343 9.56702 15.4658C9.58938 15.6472 9.79583 18.4517 9.77353 18.6331V27.4131C9.83979 28.6223 8.99726 29.6651 7.88185 29.7545Z",
    fill: "#FCEA2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18368 20.7955V16.5168C9.17122 15.3949 10.4681 13.5433 11.6503 13.3924C12.8325 13.2415 15.701 14.3857 15.8586 15.5171C15.8839 15.6985 15.8687 16.1736 15.8434 16.355L14.6563 19.7759",
    fill: "#FCEA2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 20.6184L14.8705 3.52274C14.8705 -0.0916867 20.3826 0.368736 20.3826 3.68839L20.9999 21.8071",
    fill: "#FCEA2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65396 22.5329C2.44595 22.4435 1.53353 21.4008 1.60529 20.1916V16.0942C1.4544 14.9628 2.24922 13.9232 3.38067 13.7723C4.51212 13.6214 5.55167 14.4162 5.70262 15.5477C5.7268 15.7291 5.7268 15.9128 5.70262 16.0942V20.1915C5.77439 21.4008 4.86197 22.4435 3.65396 22.5329V22.5329Z",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.627 28.4893V22.4351C20.5315 21.131 19.5831 19.7793 17.8096 19.7793",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.81 19.7832H12.9583C11.956 19.7126 11.0916 20.61 11.0176 21.7981C11.1059 23.0128 11.9222 23.9731 12.9467 24.0674L13.4556 24.1348C14.5167 24.2741 15.3847 24.9074 15.3847 25.5406V26.692V26.9453C14.3399 27.2088 13.3727 27.7964 12.5818 28.6482",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58691 29.6523C2.2062 34.6033 6.21813 38.2789 10.9228 38.2053C16.1656 38.2053 20.6269 34.2717 20.6269 28.4889L20.6263 28.4883",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3584 3.49414V12.268",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2617 3.61719V18.1442",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3584 3.495C15.3584 0.0561691 20.2606 0.458586 20.2606 3.61692",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59223 22.4528C6.64775 23.1711 5.66732 21.3207 5.73908 20.1115V16.0142C5.58818 14.8827 6.38301 13.8432 7.51446 13.6922C8.6459 13.5413 9.68546 14.3361 9.83641 15.4676C9.86059 15.649 9.86059 15.8328 9.83641 16.0141",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87287 18.57V15.4575C9.72197 14.3261 10.5168 13.2865 11.6482 13.1356C12.7797 12.9847 13.8192 13.7795 13.9702 14.9109C13.9944 15.0923 13.9944 15.2761 13.9702 15.4575L13.9883 17.5086",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58722 29.6524C1.54039 28.7677 1.58722 24.4199 1.58722 24.4199",
    stroke: "black",
    strokeWidth: 1.17067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.92b5cc4877579aafc298029bd077cb67.svg";
export { ForwardRef as ReactComponent };